import { gql } from '@apollo/client';

export const ALL_FUNDER_INSIGHTS = gql`
  query allFunderInsights($input: getInsightsInput!) {
    insights: allFunderInsights(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          users {
            id
            firstName
            lastName
          }
          tags {
            id
            name
          }
          url
          createdBy {
            id
            firstName
            lastName
          }
          createdOn
        }
      }
    }
  }
`;
